import styled from 'styled-components';

export const Container = styled.div`
  height: 96vh; // 100 - altura do header (4px)

  @media (max-width: 600px) {
    height: auto;
    min-height: 100vh;
    min-height: 100dvh;
  }
`;
